export default __webpack_public_path__ + "f99e3fd2f3844caae65fad6df2498c72.png";